import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const SunIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12.546 2a.546.546 0 0 0-1.091 0v2a.546.546 0 0 0 1.09 0V2ZM5.315 4.543a.545.545 0 1 0-.772.772l1.414 1.414a.545.545 0 0 0 .772-.772L5.315 4.543Zm6.695 2.863a4.546 4.546 0 1 1 .079 9.09 4.546 4.546 0 0 1-.08-9.09Zm1.347 1.348a3.455 3.455 0 1 0-2.616 6.395 3.455 3.455 0 0 0 2.616-6.395ZM6.73 17.27a.545.545 0 0 1 0 .772l-1.414 1.414a.545.545 0 0 1-.772-.772l1.414-1.414a.545.545 0 0 1 .772 0ZM19.457 4.543a.545.545 0 0 1 0 .772l-1.414 1.414a.545.545 0 0 1-.772-.772l1.414-1.414a.545.545 0 0 1 .772 0Zm-1.414 12.728a.545.545 0 0 0-.772.772l1.414 1.414a.545.545 0 0 0 .772-.772l-1.414-1.414ZM1.455 12c0-.301.244-.546.545-.546h2a.546.546 0 0 1 0 1.091H2A.546.546 0 0 1 1.455 12Zm18 0c0-.301.244-.546.545-.546h2a.546.546 0 0 1 0 1.091h-2a.546.546 0 0 1-.546-.545Zm-6.91 8a.546.546 0 0 0-1.09 0v2a.546.546 0 0 0 1.09 0v-2Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
